const articles = [
    {
        name: 'text-to-cogo',
        title: 'Text to COGO Tool',
        content: [
            `Convert your legal descriptions to COGO instructions within seconds!
            
            Simply paste your legal description into the text box and click the Grant my wish button.
            
            You'll get text file that is ready to be imported into ArcMap or ArcGIS Pro.`,
        ]
    },    {
        name: 'pdf-to-cogo',
        title: 'PDF to COGO',
        content: [
            `Soon you will be able to use the PDF to COGO tool converter.
            
            We are currently developing the PDF OCRS portion of the tool. 
            
            Join our email list to be notified when the tool is ready to go.`,
        ]
    },     {
        name: 'blog',
        title: 'Blog',
        content: [
            `Today is the day I talk about something which scares most people: City Ties.
            In reality, I'm not sure why people have such a hard time with proin congue
            ligula id risus posuere, vel eleifend ex egestas. Sed in turpis leo. 
            Aliquam malesuada in massa tincidunt egestas. Nam consectetur varius turpis, 
            non porta arcu porttitor non. In tincidunt vulputate nulla quis egestas. Ut 
            eleifend ut ipsum non fringilla. Praesent imperdiet nulla nec est luctus, at 
            sodales purus euismod.`,
            'Stay informed by joining our email list.',
        ]
    },  
];

export default articles;